import * as socketIOClient from "socket.io-client";
import * as sailsIOClient from "sails.io.js";
import Url from "../Url/Url";
import Constants from "../Action/Constants";
import Logger from "../Logger/Logger";
import Store from "../Store/Store";
import Environment from "../Environment/Environment";
import { SocketInterface } from "./SocketInterface";
import { SocketEventInterface } from "./SocketEventInterface";
import { LogConnect } from "./Events/LogConnect";
import { JoinAgencyRoom } from "./Events/JoinAgencyRoom";
import { JoinedAgencyRoom } from "./Events/JoinedAgencyRoom";
import { LeftAgencyRoom } from "./Events/LeftAgencyRoom";
import { LogDisconnect } from "./Events/LogDisconnect";
import { PersonCreate } from "./Events/PersonCreate";
import { PersonUpdate } from "./Events/PersonUpdate";
import { PersonDelete } from "./Events/PersonDelete";
import { CompanyCreate } from "./Events/CompanyCreate";
import { CompanyUpdate } from "./Events/CompanyUpdate";
import { CompanyDelete } from "./Events/CompanyDelete";
import { ContractCreate } from "./Events/ContractCreate";
import { ContractUpdate } from "./Events/ContractUpdate";
import { ContractDelete } from "./Events/ContractDelete";
import { ChargeCreate } from "./Events/ChargeCreate";
import { ChargeUpdate } from "./Events/ChargeUpdate";
import { ChargeDelete } from "./Events/ChargeDelete";
import { AgencyFeeCreate } from "./Events/AgencyFeeCreate";
import { AgencyFeeUpdate } from "./Events/AgencyFeeUpdate";
import { PaymentCreate } from "./Events/PaymentCreate";
import { PaymentUpdate } from "./Events/PaymentUpdate";
import { PaymentDelete } from "./Events/PaymentDelete";
import { TransactionFileCreate } from "./Events/TransactionFileCreate";
import { TransactionFileUpdate } from "./Events/TransactionFileUpdate";
import { TransactionFileProgress } from "./Events/TransactionFileProgress";
import { EventCreate } from "./Events/EventCreate";
import { EventUpdate } from "./Events/EventUpdate";
import { EventHide } from "./Events/EventHide";
import { EventDelete } from "./Events/EventDelete";
import { EventSnooze } from "./Events/EventSnooze";
import { FinancialStatementCreate } from "./Events/FinancialStatementCreate";
import { FinancialStatementUpdate } from "./Events/FinancialStatementUpdate";
import { FinancialStatementDelete } from "./Events/FinancialStatementDelete";
import { UnitCreate } from "./Events/UnitCreate";
import { UnitUpdate } from "./Events/UnitUpdate";
import { UnitDelete } from "./Events/UnitDelete";
import { PropertyCreate } from "./Events/PropertyCreate";
import { PropertyUpdate } from "./Events/PropertyUpdate";
import { ActivityTemplateCreate } from "./Events/ActivityTemplateCreate";
import { ActivityTemplateUpdate } from "./Events/ActivityTemplateUpdate";
import { ActivityTemplateDelete } from "./Events/ActivityTemplateDelete";
import { TaskTemplateCreate } from "./Events/TaskTemplateCreate";
import { TaskTemplateUpdate } from "./Events/TaskTemplateUpdate";
import { TaskTemplateDelete } from "./Events/TaskTemplateDelete";
import { TaskCreate } from "./Events/TaskCreate";
import { TaskUpdate } from "./Events/TaskUpdate";
import { TaskDelete } from "./Events/TaskDelete";
import { ChargeTemplateCreate } from "./Events/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "./Events/ChargeTemplateUpdate";
import { ChargeTemplateDelete } from "./Events/ChargeTemplateDelete";
import { BankAccountCreate } from "./Events/BankAccountCreate";
import { BankAccountUpdate } from "./Events/BankAccountUpdate";
import { BankAccountDelete } from "./Events/BankAccountDelete";
import { ChargeTypeCreate } from "./Events/ChargeTypeCreate";
import { ChargeTypeUpdate } from "./Events/ChargeTypeUpdate";
import { AgencySettingsUpdate } from "./Events/AgencySettingsUpdate";
import { ConversationCreate } from "./Events/ConversationCreate";
import { ConversationUpdate } from "./Events/ConversationUpdate";
import { PontoConnect } from "./Events/PontoConnect";
// import { PontoProgress } from "./Events/PontoProgress";
import { PontoSyncStatus } from "./Events/PontoSyncStatus";
import { PontoProcessing } from "./Events/PontoProcessing";
import { PontoProgress } from "./Events/PontoProgress";

class Socket implements SocketInterface {

  private io: any;
  private interval: any;
  private milliseconds: number = 50;
  private queue: any[] = [];
  private processing: boolean = false;
  private listeners: {
    [key: string]: SocketEventInterface[]
  } = {
    "connect": [
      new LogConnect(),
      new JoinAgencyRoom()
    ],
    "disconnect": [
      new LogDisconnect()
    ],
    "room.join": [
      new JoinedAgencyRoom()
    ],
    "room.leave": [
      new LeftAgencyRoom()
    ],
    "person.create": [
      new PersonCreate()
    ],
    "person.update": [
      new PersonUpdate()
    ],
    "person.remove": [
      new PersonDelete()
    ],
    "contact.update": [
      new PersonUpdate()
    ],
    "company.create": [
      new CompanyCreate()
    ],
    "company.update": [
      new CompanyUpdate()
    ],
    "company.remove": [
      new CompanyDelete()
    ],
    "contract.create": [
      new ContractCreate()
    ],
    "contract.update": [
      new ContractUpdate()
    ],
    "contract.remove": [
      new ContractDelete()
    ],
    "charge.create": [
      new ChargeCreate()
    ],
    "charge.update": [
      new ChargeUpdate()
    ],
    "charge.delete": [
      new ChargeDelete()
    ],
    "agency-fee.create": [
      new AgencyFeeCreate()
    ],
    "agency-fee.update": [
      new AgencyFeeUpdate()
    ],
    "payment.create": [
      new PaymentCreate()
    ],
    "payment.update": [
      new PaymentUpdate()
    ],
    "payment.delete": [
      new PaymentDelete()
    ],
    "transaction-file.create": [
      new TransactionFileCreate()
    ],
    "transaction-file.update": [
      new TransactionFileUpdate()
    ],
    "transaction-file.progress": [
      new TransactionFileProgress()
    ],
    "event.create": [
      new EventCreate()
    ],
    "event.update": [
      new EventUpdate()
    ],
    "event.hide": [
      new EventHide()
    ],
    "event.delete": [
      new EventDelete()
    ],
    "event.snooze": [
      new EventSnooze()
    ],
    "financial-statement.create": [
      new FinancialStatementCreate()
    ],
    "financial-statement.delete": [
      new FinancialStatementDelete()
    ],
    "financial-statement.update": [
      new FinancialStatementUpdate()
    ],
    "unit.create": [
      new UnitCreate()
    ],
    "unit.update": [
      new UnitUpdate()
    ],
    "unit.remove": [
      new UnitDelete()
    ],
    "property.create": [
      new PropertyCreate()
    ],
    "property.update": [
      new PropertyUpdate()
    ],
    "activityTemplate.create": [
      new ActivityTemplateCreate()
    ],
    "activityTemplate.update": [
      new ActivityTemplateUpdate()
    ],
    "activityTemplate.remove": [
      new ActivityTemplateDelete()
    ],
    "taskTemplate.create": [
      new TaskTemplateCreate()
    ],
    "taskTemplate.update": [
      new TaskTemplateUpdate()
    ],
    "taskTemplate.remove": [
      new TaskTemplateDelete()
    ],
    "task.create": [
      new TaskCreate()
    ],
    "task.update": [
      new TaskUpdate()
    ],
    "task.remove": [
      new TaskDelete()
    ],
    "chargeTemplate.create": [
      new ChargeTemplateCreate()
    ],
    "chargeTemplate.update": [
      new ChargeTemplateUpdate()
    ],
    "bank.delete": [
      new ChargeTemplateDelete()
    ],
    "bankAccount.create": [
      new BankAccountCreate()
    ],
    "bankAccount.update": [
      new BankAccountUpdate()
    ],
    "bankAccount.delete": [
      new BankAccountDelete()
    ],
    "chargeTypes.create": [
      new ChargeTypeCreate()
    ],
    "chargeTypes.update": [
      new ChargeTypeUpdate()
    ],
    "agencySettings.update": [
      new AgencySettingsUpdate()
    ],
    "conversation.create": [
      new ConversationCreate()
    ],
    "conversation.update": [
      new ConversationUpdate()
    ],
    "ponto.connect": [
      new PontoConnect()
    ],
    "ponto.sync.status": [
      new PontoSyncStatus()
    ],
    "ponto.processing": [
      new PontoProcessing()
    ],
    "ponto.progress": [
      new PontoProgress()
    ],
  };

  public connect(): void {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.process();
      }, this.milliseconds);
    }

   //We are already connected. Since sails doesn't support it, switch to the other room.
    if (this.io) {
      if (Environment.isDevelopment() === true) {
        Logger.log(`[Socket] Reconnecting without breaking existing connection.`);
      }

      // join room of current agency
      this.emit("join", { room: Store.getConfigurator().getState().app.session.user.agencyId });

      this.listeners.connect.forEach((event: SocketEventInterface) => {
        event.bindProps(Store.getConfigurator()).process({
          socket: this,
          res: {}
        });
      });

      return;
    }

    this.io = sailsIOClient(socketIOClient);
    this.io.sails.url = Url.getBackendEndpoint();
    this.io.sails.transports = ["websocket", "polling"];

    /*
    |  Iterate over each listener and apply the callbacks.
    */

    Object.keys(this.listeners || {}).forEach(listener => {
      this.io.socket.on(listener, res => {
        if (Environment.isDevelopment() === true) {
          Logger.log(`[Socket] ${listener} - pushing to queue`);
        }

        this.queue.unshift({
          listener: listener,
          listeners: this.listeners[listener],
          res: res
        });
      });
    });
  }

  public process(): void {
    const pop = this.queue.pop();

    if (typeof pop === "undefined") {
      if (this.processing === true) {
        this.processing = false;
        Store.getConfigurator().dispatch({
          type: Constants.LOADING_HIDE
        });
      }
      return;
    }

    if (this.processing === false) {
      this.processing = true;
    }

    if (Environment.isDevelopment() === true) {
      Logger.log(`[Socket] ${pop.listener} - processing`);
    }

    pop.listeners.forEach((event: SocketEventInterface) => {
      event.bindProps(Store.getConfigurator()).process({
        socket: this,
        res: pop.res
      });
    });
  }

  public emit(event: string, data: any): any {
    const path: string = Url.to(`socket/${event}`);
    return this.io.socket.post(path, data);
  }

  public unsubscribe = () => {
    if (!this.io) {
      return;
    }

    this.emit("leave", { room: Store.getConfigurator().getState().app.session.user.agencyId });
  }
}

export default new Socket();
